/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
var formattedWishlistedProducts = [];
var productCardMarkup = `
<ul class="grid product-grid grid--2-col-tablet-down grid--4-col-desktop">
  {{#products}} 
    <li class="grid__item sfl-page__card underline-links-hover">
      <button onClick="onRemoveBtnClick(event)" id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="sfl-page__remove-button-wrapper sfl-page__remove-button">
        X
      </button>
      <div class="media media--square">
        <img alt="{{dt}}" class="swym-wishlist-image" src="{{iu}}">
      </div>
      <div class="card--standard">
        <div class="card__content">
          <div class="card__information">
            <h3 class="card__heading card__heading--no-after h2">
              <a href="{{du}}" aria-label="{{dt}}" class="full-unstyled-link">
                {{dt}}
              </a>
            </h3>
            {{#hasMoreVariant}}
              {{#options}}
                <label id="swym-variant-select-dropdown">
                  <span class="h3">{{name}}: </span>              
                  <select id="swym-custom-wishlist-select" data-option-index="{{position}}" onchange="onVariantSelectChange(event, {{position}}, {{product_id}})">
                    {{#values}} 
                      <option>{{.}}</option>
                    {{/values}} 
                  </select>
                </label>
              {{/options}} 
            {{/hasMoreVariant}}
            <div class="price">
              <div class="price__container">
                <div class="price__regular">
                  <span class="visually-hidden visually-hidden--inline">Regular price</span>
                  <span class="price-item price-item--regular">
                    {{cu}}{{pr}}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="quick-add">
            <button
              onClick="onAddToCartClick(event)" 
              id="swym-custom-add-toCartBtn" 
              data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"
              data-product-url="{{du}}" 
              data-variant-id="{{epi}}" 
              data-product-id="{{empi}}" 
              class="quick-add__submit button button--full-width button--secondary"
            >
              <span>{{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}</span>
              <div class="loading__spinner hidden">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  class="spinner"
                  viewBox="0 0 66 66"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                </svg>
              </div>
            </button>
          </div>
        </div>
      </div>
    </li>
  {{/products}}
</ul>`;

function redicrectToCollections() {
  window.location = `${ window.location.host }/collections/all`;
}

function getVariantInfo(variants) {
  try {
    let variantKeys =
        variants && variants != "[]"
          ? Object.keys(JSON.parse(variants)[0])
          : [],
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}

function onAddToCartClick(e) {
  e.preventDefault();
  var productId = e.currentTarget.getAttribute("data-product-id");
  let currentProduct = formattedWishlistedProducts.find(
    (item) => item.empi == productId
  );
  var variantId = e.currentTarget.getAttribute("data-variant-id");
  console.log("current product", currentProduct);
  let selectedVariant = currentProduct.variants.find((variant) => {
    return (
      currentProduct.selectedOption &&
      variant.option1 == currentProduct.selectedOption.option1 &&
      variant.option2 == currentProduct.selectedOption.option2 &&
      variant.option3 == currentProduct.selectedOption.option3
    );
  });
  console.log("selected variant ", selectedVariant);
  var du = e.target.getAttribute("data-product-url");
  e.target.innerHTML = "Adding..";
  window._swat.replayAddToCart(
    {
      empi: productId,
      du: du,
    },
    selectedVariant ? selectedVariant.id : variantId,
    function (c) {
      e.target.innerHTML = "Added to Cart";
      e.target.setAttribute("data-state-cart", "swym-added");
      // console.log("Successfully added product to cart.", c);
    },
    function (e) {
      console.log(e);
    }
  );
}

function onVariantSelectChange(e, position, productId) {
  console.log(
    "on option changed..",
    e.target.value,
    position,
    productId,
    formattedWishlistedProducts
  );
  let selectedValue = e.target.value;
  let currentProduct = formattedWishlistedProducts.find(
    (item) => item.empi == productId
  );
  console.log("selected product ", currentProduct);
  let selectedVariant = currentProduct.variants.find(
    (variant) => variant[`option${position}`] == selectedValue
  );
  console.log("selected variant ", selectedVariant);
  currentProduct.selectedOption = {
    ...currentProduct.selectedOption,
    [`option${position}`]: selectedValue,
  };
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function (products) {
    products.forEach(function (product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function () {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  });
}

async function swymRenderWishlist(swat) {
  // Get wishlist items
  var wishlistContentsContainer = document.getElementById(
    "wishlist-items-container"
  );
  swat.fetch(async (products) => {
    if (products.length > 0) {
      document
        .querySelector("[data-empty-wishlist]")
        .classList.add("hidden");
    } else if (products.length == 0) {
      document
        .querySelector("[data-empty-wishlist]")
        .classList.remove("hidden");
    }

    formattedWishlistedProducts = await Promise.all(
      products.map(async function (p) {
        const req = await fetch(`${p.du}.json`);
        const res = await req.json();
        let product = res.product;
        p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
        p.isInCart =
          _swat.platform.isInDeviceCart(p.epi) ||
          p.et == _swat.EventTypes.addToCart;
        p.variantinfo = p.vi ? getVariantInfo(p.vi) : "";
        p.variantName =
          product.options[0].name != "Title" ? product.options[0].name : null;
        p.options = product.options;
        p.variants = product.variants;
        p.hasMoreVariant = product.variants.length >= 2;
        p.productData = product;
        return p;
      })
    );
    console.log("formated product ", formattedWishlistedProducts);

    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: formattedWishlistedProducts,
    });
    if (wishlistContentsContainer) {
      wishlistContentsContainer.innerHTML = productCardsMarkup;
    } else {
      console.log("Container not found, Wishlist Page element not found");
    }
  });
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */
